require(["domReady", "app/logging", "app/errorLogging", "app/timing"], function (domReady) {
    (function () {
        window.log("[Loading] Running initial modules.");

        require(["app/modules"], function (modules) {
            for (var i = 0; i < modules.length; i++) {
                var module = modules[i];

                if (module && module.run) {
                    module.run();
                }
            }
        });
    })();

    

    // fixes bug on mobile devices: when pressing back button on checkout the dialog stays open
    window.addEventListener("pageshow", function (evt) {
        if (evt.persisted) {
            setTimeout(function () {
                window.location.reload();
            }, 10);

            document.body.innerHTML = '';
        }
    }, false);
});
define("app/travel-main", function(){});

